/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./multi.vue?vue&type=template&id=8ac56e64&scoped=true"
import script from "./multi.vue?vue&type=script&lang=js"
export * from "./multi.vue?vue&type=script&lang=js"
import style0 from "./multi.vue?vue&type=style&index=0&id=8ac56e64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ac56e64",
  null
  
)

export default component.exports